import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GoogleAuthService {
  private clientId = '970160762702-fpg7h2unmr8914ah87g0faqocpjp9nqk.apps.googleusercontent.com';
  private scope = 'https://www.googleapis.com/auth/calendar';

  constructor() {
    // Carregar a biblioteca de GIS dinamicamente
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.onload = () => this.initializeGis();
    document.head.appendChild(script);
  }

  private initializeGis(): void {
    google.accounts.id.initialize({
      client_id: this.clientId,
      callback: (response) => this.handleCredentialResponse(response),
    });
  }

  private handleCredentialResponse(response: any): void {
    console.log('Resposta de credencial recebida:', response);
  }

  // Exibe o popup de login e retorna uma Promise com o token
  // public signIn(): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     // Configura o callback para capturar o token
  //     google.accounts.id.initialize({
  //       client_id: this.clientId,
  //       callback: (response: any) => {
  //         if (response.credential) {
  //           resolve(response.credential); // Retorna o token recebido
  //         } else {
  //           reject('Nenhuma credencial recebida');
  //         }
  //       },
  //     });

  //     // Exibe o prompt de login
  //     google.accounts.id.prompt((notification: any) => {
  //       if (notification.isNotDisplayed || notification.isSkippedMoment) {
  //         reject('O prompt de login foi ignorado ou não foi exibido');
  //       }
  //     });
  //   });
  // }

  public signIn(): Promise<string> {
    return new Promise((resolve, reject) => {
      // Configura o callback para capturar o token
      google.accounts.oauth2.initCodeClient({
        client_id: this.clientId,
        scope: 'https://www.googleapis.com/auth/calendar',
        access_type: 'offline',
        callback: (response) => {
          resolve(response.code);
        }
      }).requestCode();
    });
  }

}
